import { render, staticRenderFns } from "./viewComments.vue?vue&type=template&id=441f1210&scoped=true&"
import script from "./viewComments.vue?vue&type=script&lang=js&"
export * from "./viewComments.vue?vue&type=script&lang=js&"
import style0 from "./viewComments.vue?vue&type=style&index=0&id=441f1210&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441f1210",
  null
  
)

export default component.exports